<p-accordion [style.width]="'100%'" [value]="'notes'">
  <p-accordion-panel value="notes">
    <p-accordion-header>Notes</p-accordion-header>
    <p-accordion-content>
    <p-toast></p-toast>
    <div class="notes-delete-loading">
    <app-tab-spinner *ngIf="isDeleting" [fixed]="false"></app-tab-spinner>
    <p-table styleClass="p-datatable-gridlines" #dt [columns]="selectedColumns" [value]="rows" [customSort]="true"
      [(selection)]="selectedNote" [scrollable]="true" [scrollHeight]="scrollHeight"
      [lazyLoadOnInit]="false" [lazy]="true" [virtualScrollItemSize]="50" [loading]="isLoading"
      (onLazyLoad)="loadDataOnScroll($event)">
      <ng-template pTemplate="caption">
        <div class="multi-select" style="display: flex;justify-content: space-between;">
          <div class="global-filter" style="display: flex; align-items: center; gap: 10px;">
            <input (input)="onNotesGlobalFilter($event, dt)" type="text" pInputText size="50"
              placeholder="Global Filter" (keydown)="keepNoteEditorCaretKeys($event)" />
            <button
              *ngIf="showSmartAgentAssist && isSAAFeatureEnabled && isSAAUserEligible"
              class="crm-button smart-agent-assist-button"
              type="button"
              [disabled]="smartAgentAssistInProgress"
              [attr.aria-busy]="smartAgentAssistInProgress"
              (click)="onSmartAgentAssistClick()"
              aria-label="Load claim summary with AI assistance">
              <span class="opt8-logo" aria-hidden="true">
                <img
                  class="nl-logo-icon"
                  src="assets/saa-nl-logo.png"
                  alt=""
                  width="36"
                  height="36"
                  decoding="async" />
              </span>
              <span class="label">Agent Intelligence</span>
              <span class="sparkle-icon" aria-hidden="true">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <defs>
                    <linearGradient [attr.id]="sparkleGradientId" x1="0" y1="0" x2="1" y2="1">
                      <stop offset="0%" stop-color="#76c86b" />
                      <stop offset="52%" stop-color="#5bb3d6" />
                      <stop offset="100%" stop-color="#3c7bd6" />
                    </linearGradient>
                  </defs>
                  <path
                    d="M11.6 2.6c.2-.5.9-.5 1.1 0l1.6 4.1 4.1 1.6c.5.2.5.9 0 1.1l-4.1 1.6-1.6 4.1c-.2.5-.9.5-1.1 0l-1.6-4.1-4.1-1.6c-.5-.2-.5-.9 0-1.1l4.1-1.6 1.6-4.1z"
                    [attr.fill]="'url(#' + sparkleGradientId + ')'"
                    stroke="#ffffff"
                    stroke-opacity="0.6"
                    stroke-width="0.6"
                  />
                  <path
                    d="M17.7 13.4c.1-.3.6-.3.7 0l.9 2.2 2.2.9c.3.1.3.6 0 .7l-2.2.9-.9 2.2c-.1.3-.6.3-.7 0l-.9-2.2-2.2-.9c-.3-.1-.3-.6 0-.7l2.2-.9.9-2.2z"
                    [attr.fill]="'url(#' + sparkleGradientId + ')'"
                    opacity="0.9"
                    stroke="#ffffff"
                    stroke-opacity="0.6"
                    stroke-width="0.6"
                  />
                </svg>
              </span>
            </button>
          </div>
          <div class="top-right-icons" style="display: flex; gap: 10px;">
            <ng-container *ngIf="!viewOnly">
            <button
            *appSetRolePermissionsDirective="{type:'button', operation:'ADD', permission:'Notes', category: parentCategory}"
            (click)="showDialogToAdd()" class="crm-button" type="button" icon="fa fa-plus" label="Add">
            Add Notes
          </button>
            </ng-container>
            <button class="icon-button" (click)="onClickPrint($event,opHeader)" type="button">
            Print
            </button>
            <button class="icon-button" (click)="onClickExport()">
            Export
            </button>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [style.width]="col.width">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
          <th class="last-cell"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <td *ngFor="let col of columns;let indx = index" [style.width]="col.width">
            <div *ngIf="col.datatype==='date'">{{getFormattedDate(rowData[col.field])}}</div>
            <div *ngIf="col.datatype==='string'" [innerHTML]="displayedNoteHtml(col.field, rowData[col.field])"></div>
          </td>
          <td class="last-cell" [style.width]="'1%'">
            <div
              (click)="ellipsisClick($event,rowData,opRow,null)" class="three-dots">
              <div class="icon" [inlineSVG]="'assets/three_dots.svg'"></div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    </div>
    <p-dialog #noteDialog [header]="this.newNote ? 'Add Note' : 'Edit Note'" [visible]="displayDialog"
      (visibleChange)="onNoteDialogVisibleChange($event)" (onHide)="releaseNoteDialogScrollLock()"
      [modal]="true" [focusTrap]="!displayDiscardConfirm"
      [styleClass]="'note-dailog'" showeffect="fade">
      <div *ngIf="note" class="ui-g ui-fluid" (mousemove)="onNoteDialogPointerMove($event)"
        (mouseleave)="onNoteDialogPointerLeave()">
        <div class="ui-g-12">
          <div class="label-div ui-g-2">
            <label for="type">Type</label>
          </div>
          <div class="ui-g-10">
            <p-select #noteTypeSelect [disabled]="isViewMode" [options]="typeList" [(ngModel)]="currentType"
              (onChange)="onTypeChange($event)" id="type" appendTo="body" placeholder="Select a Type"
              optionLabel="label">
            </p-select>
          </div>
        </div>
        <div class="ui-g-12">
          <div class="label-div ui-g-2">
            <label for="note">Note</label>
          </div>
          <div class="ui-g-10 note-editor-field">
            <p-editor #noteEditor [readonly]="!note || (note && !note.isEditable)" [(ngModel)]="note.noteText"
              [style]="{'height':'220px'}" (keydown)="keepNoteEditorCaretKeys($event)"></p-editor>
          </div>
        </div>
      </div>
      <ng-template pTemplate="footer">
        <div class="p-dialog-buttonpane ui-helper-clearfix">
          <div>
            <button *ngIf="note && note.isEditable && ( newNote || (buttonAuth.Save && !newNote))" (click)="save()"
              [disabled]="noteSaveInProgress" class="crm-button" type="button" icon="fa fa-check" label="Save">
              Save
            </button>
          </div>
        </div>
      </ng-template>
    </p-dialog>
    </p-accordion-content>
  </p-accordion-panel>
</p-accordion>
<p-popover #opHeader>
  <p-listbox [options]="ellipsisHeaderOptions"
    (onClick)="this[$event.option.callback] ? this[$event.option.callback]($event, opHeader) : ellipsisOptionClick($event)"></p-listbox>
</p-popover>
<p-popover #opRow>
  <p-listbox [options]="ellipsisRowOptions"
    (onClick)="this[$event.option.callback] ? this[$event.option.callback]($event, opRow) : ellipsisOptionClick($event)"></p-listbox>
</p-popover>
<crm-export-dialog [(displayDialog)]="displayExport" [filterByColumns]="true" [fileName]="'crm-notes'" [rows]="rows"
  [filterColumnList]="selectedColumns" [dataTable]="dt" [pdfTableOptions]="pdfTableOptions">
</crm-export-dialog>
<div class="alert-dailog">
  <p-dialog [header]="'Alert'" [(visible)]="displayAlert" [modal]="true" [styleClass]="'add-dialog'"
    [blockScroll]="true" showeffect="fade">
    <div class="modal-content">
      <i class="pi pi-exclamation-triangle" style="font-size: 2em"></i>
      <p>{{disclaimer}}</p>
    </div>
    <ng-template pTemplate="footer">
      <div class="p-dialog-buttonpane ui-helper-clearfix">
        <button (click)="displayAlert=false" class="crm-button" type="submit" label="Cancel">
          OK
        </button>
      </div>
    </ng-template>
  </p-dialog>
  <p-dialog header="Note" [(visible)]="displayDiscardConfirm" [modal]="true" [styleClass]="'note-discard-dialog'"
    [baseZIndex]="20000" [blockScroll]="false" [focusOnShow]="false" [draggable]="false"
    (onShow)="restoreNoteDialogScrollLock()" (onHide)="onDiscardDialogHide()"
    appendTo="body" showeffect="fade">
    <div class="note-discard-message">
      <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
      <p>Unsaved note will be discarded</p>
    </div>
    <ng-template pTemplate="footer">
      <div class="note-discard-actions">
        <button (click)="cancelDiscardNote()" class="crm-button" type="button">
          Cancel
        </button>
        <button (click)="confirmDiscardNote()" class="crm-button" type="button">
          Confirm
        </button>
      </div>
    </ng-template>
  </p-dialog>
</div>